import buildRevisionOptions from 'app/shared/playbooks/buildRevisionOptions';

// Filter map keeps disabled revisions selectable (finding pipelines to move off a bad
// revision is a primary use); target map blocks them from being applied.
export default function buildRevisionOptionMaps({ integrations, defaultIntegrationOption, defaultRevisionOption }) {
  const revisionsByIntegrationId = integrations.reduce((map, integration) => {
    map[integration.id] = [
      defaultRevisionOption,
      ...buildRevisionOptions(integration.playbooks, { blockDisabled: false }),
    ];
    return map;
  }, {});
  revisionsByIntegrationId[defaultIntegrationOption.value] = [defaultRevisionOption];

  const targetRevisionsByIntegrationId = integrations.reduce((map, integration) => {
    map[integration.id] = buildRevisionOptions(integration.playbooks);
    return map;
  }, {});

  return { revisionsByIntegrationId, targetRevisionsByIntegrationId };
}
